import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Registration } from "../../../../../../models/registration";
import { RegistrationServiceLocation } from "../../../../../../models/registration-service-location";
import { ServiceLocation } from "../../../../../../models/service-location";
import { LocationService } from "../../../../../../services/location-controller/location.service";
import { RegistrationServiceLocationControllerService } from "../../../../../../services/location-controller/registration-service-location-controller.service";
import { ServiceLocationControllerService } from "../../../../../../services/location-controller/service-location-controller.service";
import { Store } from "../../../../../../services/store.service";
import { BaseError } from "../../../../base-error";
import {
  DeterminantControllerService,
} from "../../../../../../services/registration-controller/determinant-controller.service";

@Component({
  selector: "service-location-edit",
  templateUrl: "./service-location-edit.component.html",
  styles: [],
  providers: [ToastrService],
})
export class ServiceLocationEditComponent extends BaseError implements OnInit, OnDestroy {

  @Input() public serviceId: string;
  @Input() public registrationServiceLocation: RegistrationServiceLocation;
  @Input() public serviceLocation: ServiceLocation;
  @Input() public registration: Registration;
  @Input() public showDeterminantBuilder: boolean = false;
  @Input() public determinantMapById: { [key: string]: string };
  @Output() public formSubmit = new EventEmitter();
  @Output() public editCancel = new EventEmitter();
  public addNew: boolean;
  public subscription: any;
  public isLoading: boolean = false;

  constructor(private serviceLocationControllerService: ServiceLocationControllerService,
              private registrationServiceLocationControllerService: RegistrationServiceLocationControllerService,
              public determinantService: DeterminantControllerService,
              public locationService: LocationService,
              public store: Store,
              public toastr: ToastrService) {
    super(toastr);
  }
  public ngOnInit() {
    this.subscription = this.locationService.editData.subscribe((data) => {
      this.serviceId = data.serviceId;
      this.registration = data.registration;
      this.serviceLocation = data.serviceLocation;
      this.registrationServiceLocation = data.registrationServiceLocation;
      this.addNew = data.addNew;
      this.showDeterminantBuilder = data.showDeterminantBuilder;
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public submit() {
    if (!this.isLoading) {
      this.isLoading = true;
      if (!this.showDeterminantBuilder) {
        if (this.serviceLocation.id === undefined) {
          this.createServiceLocation(this.serviceId, this.serviceLocation);
        } else {
          this.saveServiceLocation(this.serviceLocation);
        }
      } else {
        this.updateRegistrationServiceLocation(this.registrationServiceLocation);
      }
    }
  }

  public createServiceLocation(serviceId: string, serviceLocation: ServiceLocation) {
    this.serviceLocationControllerService.createServiceLocation(serviceId, serviceLocation).subscribe(
      (data) => {
        if (this.registration && this.registration.id) {
          this.addRegistrationServiceLocation(data);
        } else {
          this.formSubmit.emit({ save: true, serviceLocation });
          this.resetForm();
          this.isLoading = false;
        }
      },
      (error) => {
        this.isLoading = false;
        this.showErrorMessage(error);
      },
    );
  }

  public saveServiceLocation(serviceLocation: ServiceLocation) {
    this.serviceLocationControllerService.saveServiceLocation(this.serviceId, serviceLocation).subscribe(
      (data) => {
        this.responseSuccessful("Location saved!");
        this.locationService.updateData();
        this.formSubmit.emit({ save: true, serviceLocation, registrationServiceLocation: this.registrationServiceLocation });
        this.resetForm();
      },
      (error) => this.showErrorMessage(error),
      () => this.isLoading = false,
    );
  }

  public addRegistrationServiceLocation(serviceLocation) {
    if (this.registration !== undefined) {
      this.registrationServiceLocation = new RegistrationServiceLocation();
      this.registrationServiceLocation.serviceLocationId = serviceLocation.id;
      this.registrationServiceLocationControllerService.createServiceLocation(this.registration.id, this.registrationServiceLocation).subscribe(
        (data) => {
          this.responseSuccessful("Location added to registration");
          this.locationService.updateData();
          this.formSubmit.emit({ save: true, serviceLocation });
          this.resetForm();
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
        () => this.isLoading = false,
      );
    }
  }

  public updateRegistrationServiceLocation(registrationServiceLocation: RegistrationServiceLocation) {
    registrationServiceLocation.registrationId = this.registration.id;
    this.registrationServiceLocationControllerService.saveRegistrationServiceLocation(registrationServiceLocation).subscribe(
      (data) => {
        this.responseSuccessful("Registration Location updated!");
        this.locationService.updateData();
        this.formSubmit.emit({ save: true, serviceLocation: this.serviceLocation, registrationServiceLocation });
        this.resetForm();
      },
      (error) => this.showErrorMessage(error),
      () => this.isLoading = false,
    );
  }

  public resetForm() {
    this.serviceLocation = null;
  }

  public deleteServiceLocation(isConfirmed) {
    if (isConfirmed) {
      return false;
    }
  }

  public closeLayer() {
    this.editCancel.emit({ cancel: true });
    this.resetForm();
  }

  public closeDetLayer() {
    this.store.state.common.determinantSection.reset();
  }

  appendDeterminant = (det) => {
    let data = JSON.parse(this.registrationServiceLocation.jsonDeterminants);
    if (!Array.isArray(data)) {
      data = [];
    }
    if (data.length === 0) {
      data.push({
        type: 'OR',
        items: []
      });
    }
    let lastItem = data[data.length - 1];
    if (lastItem.items == null) {
      lastItem = {
        type: 'OR',
        items: []
      };
      data.push(lastItem);
    }
    lastItem.items.push({
      type: det.type || 'OR',
      determinantId: det.determinantId,
    });
    this.registrationServiceLocation.jsonDeterminants = JSON.stringify(data);
  };
}
